"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "defaultCardSpec", {
  enumerable: true,
  get: function get() {
    return _cardUtils.defaultCardSpec;
  }
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextInput = _interopRequireDefault(require("react-text-input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propValidators = require("prop-validators");

var _cardUtils = require("./card-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STYLES = {
  logoWrapper: {
    height: '100%',
    position: 'absolute',
    top: 0,
    right: 0
  },
  logo: {
    display: 'inline-block',
    marginTop: 12,
    marginRight: 2
  },
  errorMessage: {
    WebkitTransition: 'all 0.25s ease-in-out',
    MozTransition: 'all 0.25s ease-in-out',
    msTransition: 'all 0.25s ease-in-out',
    OTransition: 'all 0.25s ease-in-out',
    transition: 'all 0.25s ease-in-out'
  }
};

var CardNumber =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CardNumber, _React$Component);

  function CardNumber() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardNumber);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardNumber)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: '',
      cardSpec: _cardUtils.defaultCardSpec,
      showIsRequiredError: false
      /**
       * Handle changing card number
       * Get the specific card spec for the card based on the card number pattern
       * Call parent's handleChangeCardNumber, so it knows what the card spec is
       * @param {String} cardNumber - the card number
       * @return {String} cardNumber - the sanitized card number
       */

    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeCardNumber", function (_ref) {
      var cardNumber = _ref.target.value;
      // the cardSpecs for all the cards from consumerweb-card's card-config
      // https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js#L73
      var cardSpecs = _this.props.cardSpecs;
      cardNumber = cardNumber.replace(/\D+/g, ''); // get the specific cardSpec based on the cardNumber using the autodetect from cardSpecs

      var cardSpec = cardSpecs.autodetect && (0, _cardUtils.getSpecificCardSpec)(cardSpecs, cardNumber) || _this.props.selectedCardSpec || _cardUtils.defaultCardSpec;

      _this.setState({
        cardSpec: cardSpec,
        value: cardNumber
      });

      _this.handleCheckForValue(cardNumber);

      _this.props.handleChangeCardNumber(cardNumber, cardSpec);

      return cardNumber;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckForValue", function (cardNumber) {
      var cardNumberSpecs = _this.state.cardSpec.fields.ccNumber;
      var isRequired = cardNumberSpecs.required;

      _this.setState({
        showIsRequiredError: isRequired && !cardNumber
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (_ref2) {
      var cardNumber = _ref2.target.value;

      _this.props.handleFocus(cardNumber);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (_ref3) {
      var cardNumber = _ref3.target.value;

      _this.handleCheckForValue(cardNumber);

      _this.props.handleBlur(cardNumber);
    });

    return _this;
  }

  _createClass(CardNumber, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errorMessage = _this$props.errorMessage,
          _this$props$cardSpecs = _this$props.cardSpecs.autodetect,
          autodetect = _this$props$cardSpecs === void 0 ? false : _this$props$cardSpecs;
      var cardNumberSpecs = this.state.cardSpec.fields.ccNumber; // the card type from config separates words with a '_',
      // but we don't want '_'s so we can use the font icons

      var cardType = autodetect ? this.state.cardSpec.type.replace('_', '') : this.props.selectedCardSpec.type.replace('_', '');
      var cardLogoClassNames = !(errorMessage || this.state.showIsRequiredError) && "icon icon-medium icon-".concat(cardType, "-logo");
      var errorStyles = {
        height: 0,
        padding: 0
      };

      if (errorMessage) {
        errorStyles = {
          height: '100%'
        };
      }

      if (this.props.dir === 'rtl') {
        delete STYLES.logoWrapper['right'];
        STYLES.logoWrapper = _objectSpread({}, STYLES.logoWrapper, {
          left: 0
        });
        delete STYLES.logo['marginRight'];
        STYLES.logo = _objectSpread({}, STYLES.logo, {
          marginLeft: 2
        });
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'vx_has-error-with-message': errorMessage,
          'vx_has-error': !errorMessage && this.state.showIsRequiredError
        }),
        style: {
          margin: '10px 0 0',
          position: 'relative'
        }
      }, _react.default.createElement(_reactTextInput.default, {
        type: "tel",
        value: this.state.value,
        id: "cardNumber",
        name: "cardNumber",
        className: "vx_form-control vx_form-control_complex",
        label: this.props.label,
        maxLength: cardNumberSpecs.maxlength,
        pattern: cardNumberSpecs.pattern || undefined,
        required: cardNumberSpecs.required,
        onChange: this.handleChangeCardNumber,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        dir: this.props.dir
      }), _react.default.createElement("span", {
        style: STYLES.logoWrapper
      }, _react.default.createElement("span", {
        className: cardLogoClassNames,
        style: STYLES.logo
      })), _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'vx_form-control-message': errorMessage
        }),
        style: _objectSpread({}, STYLES.errorMessage, {
          errorStyles: errorStyles
        })
      }, errorMessage));
    }
  }]);

  return CardNumber;
}(_react.default.Component);

_defineProperty(CardNumber, "defaultProps", {
  handleFocus: function handleFocus() {},
  handleBlur: function handleBlur() {}
});

CardNumber.propTypes = process.env.NODE_ENV !== "production" ? {
  cardSpecs: _propValidators.cardSpecsPropType,
  selectedCardSpec: _propValidators.cardSpecPropType,
  label: _propTypes.default.string.isRequired,
  errorMessage: _propTypes.default.string,
  handleChangeCardNumber: _propTypes.default.func.isRequired,
  handleFocus: _propTypes.default.func,
  handleBlur: _propTypes.default.func,
  dir: _propTypes.default.string
} : {};
var _default = CardNumber;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-card-number/dist/index.js
// module id = 1022
// module chunks = 5